import React from "react";
import { format } from "date-fns";

export const setPayrollValues = (methods, payrollData) => {
  const {
    register,
    setValue,
    getValues,
    watch,
    handleSubmit,
    formState: { errors },
  } = methods;

  if (payrollData?.length > 0) {
    payrollData?.forEach((data, index) => {
      setValue(`payrollData[${index}].companyCode`, data.companyCode);
      setValue(`payrollData[${index}].employeeCode`, data.employeeCode);
      setValue(`payrollData[${index}].fullName`, data.fullName);
      setValue(`payrollData[${index}].icNo`, data.icNo);
      setValue(
        `payrollData[${index}].basicSalary`,
        Number(data.basicSalary).toFixed(2)
      );
      setValue(
        `payrollData[${index}].hourlySalary`,
        Number(data.hourlySalary).toFixed(2)
      );
      setValue(
        `payrollData[${index}].daySalary`,
        Number(data.daySalary).toFixed(2)
      );
      setValue(
        `payrollData[${index}].monthlySalary`,
        Number(data.monthlySalary).toFixed(2)
      );
      setValue(`payrollData[${index}].payMonth`, data.payMonth);
      setValue(`payrollData[${index}].processDate`, data.processDate);
      setValue(`payrollData[${index}].procesMonth`, data.procesMonth);
      setValue(`payrollData[${index}].processYear`, data.processYear);
      setValue(`payrollData[${index}].paymentCode`, data.paymentCode);
      setValue(`payrollData[${index}].departmentCode`, data.departmentCode);
      setValue(`payrollData[${index}].paymentMode`, data.paymentMode);
      setValue(
        `payrollData[${index}].grossSalary`,
        Number(data.grossSalary).toFixed(2)
      );
      setValue(
        `payrollData[${index}].addition`,
        Number(data.addition).toFixed(2)
      );
      setValue(
        `payrollData[${index}].deduction`,
        Number(data.deduction).toFixed(2)
      );
      setValue(`payrollData[${index}].refNo`, data.refNo);
      setValue(
        `payrollData[${index}].employeePercentage`,
        Number(data.employeePercentage).toFixed(2)
      );
      setValue(
        `payrollData[${index}].employerPercentage`,
        Number(data.employerPercentage).toFixed(2)
      );
      setValue(
        `payrollData[${index}].totalPercentage`,
        Number(data.totalPercentage).toFixed(2)
      );
      setValue(`payrollData[${index}].contributionCode`, data.contributionCode);
      setValue(`payrollData[${index}].contributionName`, data.contributionName);
      setValue(`payrollData[${index}].agencyName`, data.agencyName);
      setValue(
        `payrollData[${index}].agencyAmount`,
        Number(data.agencyAmount).toFixed(2)
      );
      setValue(
        `payrollData[${index}].sdlAmount`,
        Number(data.sdlAmount).toFixed(2)
      );
      setValue(`payrollData[${index}].leaveTakenInDays`, data.leaveTakenInDays);
      setValue(
        `payrollData[${index}].leaveSalaryAmount`,
        Number(data.leaveSalaryAmount).toFixed(2)
      );
      setValue(
        `payrollData[${index}].totalCPF`,
        Number(data.totalCPF).toFixed(2)
      );
      setValue(
        `payrollData[${index}].employeeCPF`,
        Number(data.employeeCPF).toFixed(2)
      );
      setValue(
        `payrollData[${index}].employerCPF`,
        Number(data.employerCPF).toFixed(2)
      );
      setValue(`payrollData[${index}].createUser`, data.createUser);
      setValue(
        `payrollData[${index}].salaryPayable`,
        Number(data.salaryPayable).toFixed(2)
      );
      setValue(`payrollData[${index}].payrollValue`, data.payrollValue);
      setValue(`payrollData[${index}].leaveDays`, data.leaveDays);
      setValue(
        `payrollData[${index}].leaveAmount`,
        Number(data.leaveAmount).toFixed(2)
      );
      setValue(`payrollData[${index}].netPay`, Number(data.netPay).toFixed(2));
      setValue(`payrollData[${index}].additionalHours`, data.additionalHours);
      setValue(`payrollData[${index}].deductionHours`, data.deductionHours);
      setValue(
        `payrollData[${index}].otHourlySalary`,
        Number(data.otHourlySalary).toFixed(2)
      );
      setValue(
        `payrollData[${index}].noOfOTWorkingDays`,
        data.noOfOTWorkingDays
      );
      setValue(`payrollData[${index}].noOfWorkingDays`, data.noOfWorkingDays);
      setValue(`payrollData[${index}].otDaySalary`, data.otDaySalary);
      setValue(
        `payrollData[${index}].noOfOTWorkingDaysSalary`,
        data.noOfOTWorkingDaysSalary
      );
      setValue(`payrollData[${index}].noOfDaysInMonth`, data.noOfDaysInMonth);

      setValue(`payrollData[${index}].waitingTime`, data.waitingTime);
      setValue(
        `payrollData[${index}].waitingTimeSalary`,
        data.waitingTimeSalary
      );
      setValue(`payrollData[${index}].advancePayment`, data.advancePayment);
      setValue(
        `payrollData[${index}].normalWorkingHoursInMonth`,
        data.normalWorkingHoursInMonth
      );
      setValue(
        `payrollData[${index}].normalWorkingHoursSalary`,
        data.normalWorkingHoursSalary
      );
      setValue(`payrollData[${index}].oT1Hours`, data.oT1Hours);
      setValue(`payrollData[${index}].oT1HourlySalary`, data.oT1HourlySalary);
      setValue(`payrollData[${index}].oT2Hours`, data.oT2Hours);
      setValue(`payrollData[${index}].oT2HourlySalary`, data.oT2HourlySalary);
      setValue(`payrollData[${index}].extraHours`, data.extraHours);
      setValue(`payrollData[${index}].extraHoursSalary`, data.extraHoursSalary);
      setValue(
        `payrollData[${index}].publicHolidayOTHours`,
        data.publicHolidayOTHours
      );
      setValue(
        `payrollData[${index}].publicHolidayOTHoursSalary`,
        data.publicHolidayOTHoursSalary
      );
      setValue(`payrollData[${index}].paidLeaveDays`, data.paidLeaveDays);
      setValue(`payrollData[${index}].paidLeaveSalary`, data.paidLeaveSalary);
      setValue(`payrollData[${index}].publicHolidayHours`, data.publicHolidayHours);
      setValue(`payrollData[${index}].publicHolidayHoursSalary`, data.publicHolidayHoursSalary);
      setValue(
        `payrollData[${index}].extraorlessHourAmt`,
        data.extraorlessHourAmt
      );
      setValue(`payrollData[${index}].payrollDetails`, [
        ...data.payrollDetails,
      ]);
    });
  } else {
    setValue(`payrollData`, []);
  }
};
